import Vue from 'vue'
import VueI18n from 'vue-i18n'
import store from '@/store/store'
import jp from './ja'
import us from './us'
import cn from './cn'
import tw from './tw'
import kr from './kr'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: store.getters['settings/getLanguage'],
  fallbackLocale: process.env.VUE_APP_LANG,
  messages: {
    ja: jp,
    us,
    kr,
    'zh-cn': cn,
    'zh-tw': tw,
  },
})

export default i18n
